import React from 'react';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getStyles = (_, { palette = {} }) => ({
  divider: {
    backgroundColor: palette.neutralLight,
    height: 1,
    width: '100%',
    margin: '10px 0px',
  },
});

export const HorizontalDivider = () => {
  const classes = useDefaultStyles(getStyles);

  return (<div className={classNames('horizontal-divider', classes.divider)} />);
};
